import { Component, Input, Inject, DestroyRef, inject, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { itemsPerPageList, PAYMENT_MODE, SPOT_TYPE_LABEL, UNDER_MAINTANCE_ERROR, UNDER_MAINTANCE_GREATERTIME, Utility } from 'src/app/shared';
import { ChartData, ChartOptions } from 'chart.js';
import { DOCUMENT, formatDate } from '@angular/common';
import { ToastService } from 'src/app/shared/services/toast.service';
import { RemoveDecimalPipe } from 'src/app/shared/custom-date-pipe';
import { TransactionService } from '@core/services/transaction.service';
import { TransactionData, DriverTransactionResponse, GetTransactionResponse, TransactionRequest } from '@core/models/transaction.model';
import { SuperAdminService } from '@core/services/super-admin.service';
import { CommonFunctions } from '@shared/common-functions';
import { PaymentMode } from '@core/models/api-response.model';
import { ItemPerPage } from '@core/models/file-response.model';
import { autoUnsubWith } from '@shared/services/utility.abstract';
@Component({
  selector: 'app-transaction',
  templateUrl: './transaction.component.html',
  styleUrls: ['./transaction.component.scss']
})

export class TransactionComponent implements OnInit{
  readonly destroyRef = inject(DestroyRef);
  highestPaymentData: DriverTransactionResponse[];
  transactionlist: TransactionData[] = [];
  exportFile: any
  logo: string = "assets/images/table-img.png";
  startdate: string = '';
  enddate: string = '';
  MCNumber: string = '';
  account: string = "assets/images/dummy-img.png";
  @Input() outlined: boolean = false;
  items: MenuItem[] | undefined;
  chartOptions: ChartOptions;
  revenueData: ChartData;
  totalItems: number = 0; // Total number of items from the API
  itemsPerPage: number = 10; // Number of items per page
  first: number = 0;
  DateSlot = [];
  showPicker: boolean = true;
  spotTypeMsg: string = SPOT_TYPE_LABEL;
  searchStatus:number = 0;
  selectStatus: { name: string; value: number }[] = [];
  hideAdvanceFilter : boolean = true;
  parkingLotByStatesList: any = [];
  parkingLotByStatesListWithAll: any[];
  selectedParkingLots = [];
  companyId : string;
  CustomItemPerPageBy: ItemPerPage[] = itemsPerPageList;
  SearchItemPerPageBy: any;
  showParkingLotAsterisk: boolean = false;
  pageNumber : number = 1;
  bookingTypeOption = [];
  bookingType: number = null;

  constructor(
    private readonly transactionService: TransactionService,
    private readonly toastService: ToastService,
    private readonly superAdminService : SuperAdminService,
    @Inject(DOCUMENT) private readonly _document: Document
  ) { }

  ngOnInit() {
    this.companyId = localStorage.getItem('companyId');
    this.getParkingLotByStatesName(true);
    this.search();
    this.bookingTypeOption = [
      { name: 'All', value: null },
      { name: 'One Time', value: 0 },
      { name: 'Recurring', value: 2 }
    ]
    this.items = [
      {
        items: [
          {
            label: 'Export',
            icon: 'pi pi-download',
            command: () => {
              this.getTransactionsexport();
            }
          },
        ]
      },
    ];
    this.selectStatus = [
      { name: 'All', value: 0 },
      { name: 'Received', value: 1 },
      { name: 'Refunded', value: 2 },
    ];

    this.DateSlot = [
      { name: 'Custom', value: '', flag: true },
      { name: 'Last 30 days', value: 30, flag: false },
      { name: 'Last 60 days', value: 60, flag: false },
      { name: 'Last 90 days', value: 90, flag: false },
    ]
  }

  // Function to handle dropdown change
  onDateSlotChange(event) {
    const selectedOption = this.DateSlot.find(option => option.value === event.value);
    if (selectedOption) {
      const currentDate = new Date();
      this.startdate =
        this.formatDateToString(new Date(currentDate.getTime() - (selectedOption.value * 24 * 60 * 60 * 1000)));
      this.enddate = this.formatDateToString(currentDate);
      if (this.startdate == this.enddate) {
        this.startdate = '';
        this.enddate = '';
      }
      this.showPicker = selectedOption.flag;
    }
  }
  onDropdownChange(event: any) {
    this.itemsPerPage = event.value;
    this.first = 0;
    this.pageNumber= 1;
    CommonFunctions.scrollTopRow('top');
    this.search();
  }

  formatDateToString(date: Date): string {
    return formatDate(date, 'MM/dd/yyyy HH:mm', 'en-US');
  }

  getHighestPaymentOfDriver(req): void {
    
    this.transactionService.getHighestPaymentOfDriver(req)
      .pipe(autoUnsubWith(this.destroyRef)).subscribe({
        next: (response: DriverTransactionResponse[]) => {
          this.highestPaymentData = response;
          
        }
      })
  }
  toggleHideAdvanceFilter() {
    this.hideAdvanceFilter = !this.hideAdvanceFilter;;
  }
  reset() {
    this.startdate = null;
    this.enddate = null;
    this.MCNumber = null;
    this.SearchItemPerPageBy = null;
    this.pageNumber = 1;
    this.first = 0;
    this.search();
    this._document.defaultView.location.reload();
  }
  onChangePaymentStatus(event: any) {
    this.searchStatus = event.value;
  }
  onBookingTypeChange(event) {
    this.bookingType = event;
    this.search();
  }

  search() {
    if (this.startdate && this.enddate) {
      const startDate = new Date(this.startdate);
      startDate.setSeconds(0, 0);  // Set seconds and milliseconds to 0

      const endDate = new Date(this.enddate);
      endDate.setSeconds(0, 0);

      if (startDate >= endDate) {
        this.toastService.showToastMessage('error', 'Error', UNDER_MAINTANCE_GREATERTIME);
        return;
      }
    } else if (this.startdate || this.enddate) {
      this.toastService.showToastMessage('error', 'Error', UNDER_MAINTANCE_ERROR);
      return;
    }
    if (this.selectedParkingLots?.length === 0) {
      this.showParkingLotAsterisk = true;
      return;
    }

    const req: TransactionRequest = {
      startDateTime: this.startdate,
      endDateTime: this.enddate,
      MCNumber: this.MCNumber,
      pageSize: this.itemsPerPage,
      pageNumber: this.pageNumber,
      transactionType : this.searchStatus,
      bookingType : this.bookingType,
      parkinglotIds : this.selectedParkingLots.map(item => item.id).filter(id=>id!==null && id !== undefined),
      timeZone: Utility.getLocalTimeZone()
    };

    this.getHighestPaymentOfDriver(req);
    this.getTransactionsByOwner(req);
    this.getTransactionOverview();
  }
  getTransactionsexport() {
    const reqforExport: TransactionRequest = {
      startDateTime: this.startdate,
      endDateTime: this.enddate,
      MCNumber: this.MCNumber,
      pageSize: 0,
      pageNumber: 0,
      transactionType : this.searchStatus,
      bookingType : this.bookingType,
      parkinglotIds : this.selectedParkingLots.map(item => item.id).filter(id=>id!==null && id !== undefined),
      timeZone: Utility.getLocalTimeZone()
    };
    
    this.transactionService.getTransactionsByOwner(reqforExport)
      .pipe(autoUnsubWith(this.destroyRef))
      .subscribe({
        next: (response: GetTransactionResponse) => {
          this.totalItems = response.totalRecords;
          this.exportFile = response.transactionList;
          this.export();
          
        },
        error: () => {
        }
      })
  }

  getParkingLotByStatesName(initial: boolean = false) {
    
    const req = {
      companyIds: [this.companyId]
    };
    this.superAdminService.getParkingLotNamesByCompanyIds(req)
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: (response: any) => {
        this.parkingLotByStatesList = response.data;
        this.parkingLotByStatesListWithAll = [...this.parkingLotByStatesList];
        this.selectedParkingLots = this.parkingLotByStatesList;
        this.showParkingLotAsterisk = false;
        if(initial) {
          this.search();
        }
        
      },
      error: (_error: any) => {
        
        this.parkingLotByStatesList = [];
        this.parkingLotByStatesListWithAll = [];
        this.selectedParkingLots = [];
      },
    });
  }
  onParkingLotSelectionChange(event) {
    this.showParkingLotAsterisk = false;
    const selectedValues = event.value as string[];
    if (selectedValues.includes('all')) {
      if (selectedValues?.length === this.parkingLotByStatesListWithAll?.length) { 
        return;
      }
      this.selectedParkingLots = this.parkingLotByStatesList.map(lot => lot.name);
    } else {
      const index = this.selectedParkingLots.indexOf('all');
      if (index !== -1) {
        this.selectedParkingLots.splice(index, 1);
      }
      this.selectedParkingLots = selectedValues;
    }
  }

  getTransactionsByOwner(req) {
    
    this.transactionService.getTransactionsByOwner(req)
      .pipe( autoUnsubWith(this.destroyRef))
      .subscribe({
        next: (response: GetTransactionResponse) => {
          this.transactionlist = response.transactionList;
          this.totalItems = response.totalRecords;
          this.exportFile = this.transactionlist;
        },
        error: () => {
        }
      })
  }

  getTransactionOverview() {
    
    const req = {
      year: new Date().getFullYear(),
      bookingType: this.bookingType,
      transactionType : this.searchStatus,
      parkinglotIds : this.selectedParkingLots.map(item => item.id).filter(id=>id!==null && id !== undefined),
    }
    this.transactionService.getTransActionBySuperAdmin(req)
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: (response: any) => {
        this.createChart(response.data, () => { 
        });
      }
    });
  }
 
  createChart(data: any,  _p0: () => void) {
    const modifiedData = {
      month: data.map(item => item.month),
      year: data.map(item => item.year),
      datasets: [
        {
          label: 'Received',
          data: data.map(item => item.revenue.received)
        },
        {
          label: 'Refunded',
          data: data.map(item => item.revenue.refunded)
        }
      ]
    };

    // Process data to keep labels and adjust datasets
    const labels = modifiedData.month.map((month, index) => month.substring(0, 3) + " " + String(modifiedData.year[index]).slice(-2));
    const receivedData = modifiedData.datasets[0].data.map(value => value > 0 ? value : null);
    const creditedData = modifiedData.datasets[1].data.map(value => value > 0 ? value : null);

    this.revenueData = {
      labels: labels,
      datasets: [
        {
          label: 'Received',
          data: receivedData,
          backgroundColor: 'rgb(135, 206, 235,0.11)', // #FFF5D1
          borderColor: 'rgb(135, 206, 235)',
          borderWidth: 2.5,
          pointRadius: 5,
          pointHoverRadius: 7,
          pointStyle: 'circle'
        },
        {
          label: 'Refunded',
          data: creditedData,
          backgroundColor: 'rgba(199, 0, 88 ,0.2)',
          borderColor: 'rgba(199, 0, 88 ,1)',
          borderWidth: 2.5,
          pointRadius: 5,
          pointHoverRadius: 7,
          pointStyle: 'circle'
        }
      ]
    };

    this.chartOptions = {
      responsive: true,
      aspectRatio: 1.3,
      maintainAspectRatio: false,
      scales: {
        x: {
          type: 'category',
        },
        y: {
          beginAtZero: true,
        }
      },
      plugins: {
        tooltip: {
          callbacks: {
            label: function (context) {
              let label = context.dataset.label || '';
              if (label) {
                label += ': ';
              }
              if (context.parsed.y !== null) {
                label += '$' + context.parsed.y.toFixed(2); // Add dollar sign before the value
              }
              return label;
            }
          }
        },
        legend: {
          position: 'bottom',
          align: 'center',
          labels: {
            boxHeight: 12,
            boxWidth: 12
          },
        }
      },
      layout: {
        padding: {
          left: 20,
          right: 20,
          top: 10,
        }
      },
      elements: {
        line: {
          tension: 0.5, // Adjust the tension value as needed
        }
      }
    };
  }

  export() {
    const myCustomPipe = new RemoveDecimalPipe();
    if (this.exportFile) {
      const headers = [
        { header: 'S.No', key: 'index', formatter: (value) => value + 1 },
        { header: 'Name', key: 'userType', formatter: (_value, item) => item.userType === 'Group Operator' ? item.groupCompanyName : item.driverName },
        { header: 'Email', key: 'driverEmail' },
        { header: 'User Type', key: 'userType' },
        { header: 'Spot Type', key: 'equipmentType' },
        { header: 'LP Number', key: 'licenseNumberPlate', formatter: (value) => value || '-' },
        { header: 'Invoice No.', key: 'invoiceNumber' },
        { header: 'Company Name', key: 'companyName' },
        { header: 'Parking Name', key: 'parkingLotName' },
        { header: 'Spot Count', key: 'spotCount' },
        { header: 'Booking Type', key: '', formatter: (_value, item) => (item.bookingType > 0 || item.parentId != null) ? 'Recurring' : 'One Time' },
        { header: 'Billing Cycle', key: '', formatter: (_value, item) => (item.bookingType > 0 || item.parentId != null) ? item.billingCycle : 1 },
        { header: 'MC Number', key: 'mcNumber', formatter: (value) => value || '-' },
        { header: 'Arrival Date/Time', key: 'startDate', formatter: (value) => new Date(value) },
        { header: 'Departure Date/Time', key: 'endDate', formatter: (value) => new Date(value) },
        { header: 'Base Amount', key: 'amount', formatter: (value) => myCustomPipe.transform(value) },
        { header: 'Parking Discount', key: 'discount', formatter: (value) => myCustomPipe.transform(value) },
        { header: 'Coupon Discount', key: 'couponDiscount', formatter: (value) => myCustomPipe.transform(value) },
        { header: 'Taxes', key: 'taxAndFees', formatter: (value) => myCustomPipe.transform(value) },
        { header: 'Transaction Fee', key: 'transactionFees', formatter: (value) => myCustomPipe.transform(value) },
        { header: 'Received ($)', key: 'receivedAmount' },
        { header: 'Payment Mode', key: 'bookingPaymentMode', formatter: (value) => value === PaymentMode.Online ? PAYMENT_MODE.ONLINE : value === PaymentMode.Offline ? PAYMENT_MODE.OFFLINE : '', },
{
          header: 'Received Date',
          key: 'receivedDate',
          formatter: (value) => {
            const [datePart] = value ? value.split(' - ') : ['-'];
            return new Date(datePart);
          }
        },
        {
          header: 'Received Time',
          key: 'receivedDate',
          formatter: (value) => {
            const [, timePart] = value ? value.split(' - ') : [null, '-'];
            return timePart;
          }
        },        { header: 'Refunded ($)', key: '', formatter: (_value, item) => item.receivedAmount === 0 ? 0 : item.refundAmount === 0 ? '-' : myCustomPipe.transform(item.refundAmount) },
        { header: 'Refunded Date & Time', key: 'refundDate', formatter: (value) => value ? new Date(value) : '-' },
      ];

      const dataWithIndex = this.exportFile?.map((item, index) => ({
        ...item,
        index, // Add the index to each row
      }));

      return CommonFunctions.exportToExcel(dataWithIndex, headers, 'Transactions_export_')
    }
  }

  onPageChange(event) {
    this.first = event.first;
    this.pageNumber = event.page + 1;
    CommonFunctions.scrollTopRow('top');
    this.search();
  }
  numbersOnlyValidator(event: any) {
    const pattern = /^[0-9\-]*$/;
    if (!pattern.test(event.target.value)) {
      event.target.value = event.target.value.replace(/[^0-9\-]/g, "");
    }
  }
}